module.exports = __webpack_public_path__ + "media/application/images/demo/content_7-c2593de8c52028078e8e0840cf51143b.jpg";